import Vue from 'vue'
import store from '..'
import firebase from 'firebase/app'
import 'firebase/firestore'

export default {
  namespaced: true,
  state () {
    return {
      students: [],
      reference: null,
      initial: {
        key: null,
        status: 1,
        name: null,
        sei: null,
        mei: null,
        seiY: null,
        meiY: null,
        birth: null,
        gender: null,
        avatar: null,
        school: null,
        grade: null,
        admission: null,
        secession: null,
        graduation: null,
        charge: null,
        schools: {},
        groups: {},
        contacts: [],
        events: [],
        characteristics: [],
        imported: false,
        tyg: null,
        restore: false,
        enable: true,
        createdAt: null,
        updatedAt: null
      },
      contact: {
        id: null,
        type: null,
        sei: null,
        mei: null,
        seiY: null,
        meiY: null,
        gender: null,
        address: null,
        address2: null,
        zip: null,
        email: null,
        email2: null,
        phone: null,
        mobile: null,
        memo: null,
        available1: { from: null, to: null, flag: true },
        available2: { from: null, to: null, flag: true }
      },
      event: {
        id: null,
        status: null,
        grade: null,
        type: null,
        media: null,
        memo: null,
        tyg: null,
        date1: null,
        date2: null,
        time1: null,
        time2: null,
        charge: null,
        attaches: [],
        enable: true,
        counter: 0,
        createdAt: null,
        updatedAt: null
      }
    }
  },
  getters: {
    students (state) {
      return state.students
    },
    reference (state) {
      return state.reference
    },
    initial (state) {
      return state.initial
    },
    contact (state) {
      return state.contact
    },
    event (state) {
      return state.event
    }
  },
  mutations: {
    init (state, payload) {
      state.students = payload
    },
    add (state, payload) {
      state.students.push(payload)
    },
    update (state, payload) {
      const index = state.students.findIndex(student => student.key === payload.key)
      if (index !== -1) {
        Vue.set(state.students, index, payload)
      }
    },
    remove (state, payload) {
      const index = state.students.findIndex(student => student.key === payload.key)
      if (index !== -1) {
        state.students.splice(index, 1)
      }
    },
    reference (state, payload) {
      state.reference = payload
    }
  },
  actions: {
    init ({ commit }) {
      return new Promise((resolve) => {
        commit('init', [])
        resolve()
      })
    },
    subscribe ({ commit }, payload) {
      var boot = true
      var temp = []
      return new Promise((resolve, reject) => {
        commit('init', [])
        const db = firebase.firestore()
        var dbRef = db.collection('students')
        var reference = null
        if (payload) {
          reference = dbRef.where('schools.' + payload, '==', true).where('enable', '==', true).onSnapshot(snapshots => {
            if (snapshots.empty) {
              resolve()
            }
            snapshots.docChanges().forEach(change => {
              var data = JSON.parse(JSON.stringify(change.doc.data()))
              if (boot && change.type === 'added') {
                temp.push(data)
              } else if (change.type === 'added') {
                commit('add', data)
              } else if (change.type === 'modified') {
                commit('update', data)
              } else if (change.type === 'removed') {
                commit('remove', data)
              }
            })
            if (boot) {
              boot = false
              commit('init', temp)
            }
            resolve()
          })
        } else {
          reference = dbRef.onSnapshot(snapshots => {
            if (snapshots.empty) {
              resolve()
            }
            snapshots.docChanges().forEach(change => {
              var data = JSON.parse(JSON.stringify(change.doc.data()))
              if (boot && change.type === 'added') {
                temp.push(data)
              } else if (change.type === 'added') {
                commit('add', data)
              } else if (change.type === 'modified') {
                commit('update', data)
              } else if (change.type === 'removed') {
                commit('remove', data)
              }
            })
            if (boot) {
              boot = false
              commit('init', temp)
            }
            resolve()
          })
        }
        commit('reference', reference)
      })
    },
    unSubscribe ({ commit }) {
      var reference = store.getters['students/reference']
      return new Promise((resolve) => {
        if (reference) {
          reference()
          commit('reference', null)
          commit('init', [])
          resolve()
        } else {
          resolve()
        }
      })
    },
    write ({ commit }, payload) {
      return new Promise((resolve) => {
        // const startTime = Date.now()
        const db = firebase.firestore()
        var name = ''
        if (payload.sei !== null && payload.mei !== null) {
          name = payload.sei + ' ' + payload.mei
        } else if (payload.sei !== null) {
          name = payload.sei
        } else {
          name = payload.seiY + ' ' + payload.meiY
        }
        payload.name = name
        var ref = null
        if (payload.key) {
          ref = db.collection('students').doc(payload.key)
        } else {
          ref = db.collection('students').doc()
          payload.key = ref.id
        }
        ref.set(payload)
          .then(function () {
            // const endTime = Date.now()
            // console.log('Document successfully written!', endTime - startTime)
            resolve(payload)
          })
          .catch(function (error) {
            if (error) {}
            // console.error('Error writing document: ', error)
            resolve()
          })
      })
    },
    copy ({ commit }, payload) {
      return new Promise((resolve) => {
        const db = firebase.firestore()
        var ref = db.collection('students').doc()
        payload.key = ref.id
        for (var i in payload.events) {
          payload.events[i]['key'] = ref.id
        }
        ref.set(payload)
          .then(function () {
            resolve(ref.id)
          })
          .catch(function (error) {
            if (error) {}
            // console.error('Error writing document: ', error)
            resolve()
          })
      })
    },
    disable ({ commit }, key) {
      return new Promise((resolve) => {
        const db = firebase.firestore()
        var payload = { enable: false }
        db.collection('students').doc(key).update(payload).then(function () {
          // console.log('Document successfully disabled!')
          resolve()
        }).catch(function (error) {
          if (error) {}
          // console.error('Error removing document: ', error)
          resolve()
        })
      })
    },
    delete ({ commit }, payload) {
      return new Promise((resolve) => {
        const db = firebase.firestore()
        db.collection('students').doc(payload).delete().then(function () {
          // console.log('students deleted!', payload)
          resolve()
        }).catch(function (error) {
          if (error) {}
          // console.error('Error removing document: ', error)
          resolve()
        })
      })
    }
  }
}
